const doc = [
    {
        depth2: '가계대출 세대원 비대면 동의',
        depth3: '고객정보 입력',
        depth4: '',
        depth5: '',
        name: '가계대출 세대원 비대면 동의 고객정보 입력',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1000-F',
        plan: '25.07.04',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250702:알아두세요위치수정, 250721:클래스 추가, 250828 하단 문구수정',
        uxw: true,
    },
    {
        depth2: '가계대출 세대원 비대면 동의',
        depth3: '약관 동의',
        depth4: '',
        depth5: '',
        name: '가계대출 세대원 비대면 동의 약관 동의',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1002-F',
        plan: '25.07.04',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '가계대출 세대원 비대면 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '가계대출 세대원 비대면 동의 동의 완료안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1003-F',
        plan: '25.07.04',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '개인(신용)정보 조회 동의',
        depth3: '동의 내용안내',
        depth4: '',
        depth5: '',
        name: '개인(신용)정보 조회 동의 동의 내용안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1010-F',
        plan: '25.07.11',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '개인(신용)정보 조회 동의',
        depth3: '약관 동의',
        depth4: '',
        depth5: '',
        name: '개인(신용)정보 조회 동의 약관 동의',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1012-F',
        plan: '25.07.11',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250702:알아두세요위치수정',
        uxw: true,
    },
    {
        depth2: '개인(신용)정보 조회 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '개인(신용)정보 조회 동의 동의 완료안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1013-F',
        plan: '25.07.11',
        end: '25.06.19',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '군간부 배우자 비대면 동의',
        depth3: '동의 내용안내',
        depth4: '',
        depth5: '',
        name: '군간부 배우자 비대면 동의 동의 내용안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1020-F',
        plan: '25.07.11',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '군간부 배우자 비대면 동의',
        depth3: '약관 동의',
        depth4: '',
        depth5: '',
        name: '군간부 배우자 비대면 동의 약관 동의',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1022-F',
        plan: '25.07.11',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '군간부 배우자 비대면 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '군간부 배우자 비대면 동의 동의 완료안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1023-F',
        plan: '25.07.11',
        end: '25.06.20',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '온라인 전입세대정보 확인 동의',
        depth3: '고객정보 입력',
        depth4: '',
        depth5: '',
        name: '온라인 전입세대정보 확인 동의 고객정보 입력',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1040-F',
        plan: '25.07.04',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250702:알아두세요위치수정',
        uxw: true,
    },
    {
        depth2: '온라인 전입세대정보 확인 동의',
        depth3: '신청정보 확인',
        depth4: '',
        depth5: '',
        name: '온라인 전입세대정보 확인 동의 신청정보 확인',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1042-F',
        plan: '25.07.04',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '온라인 전입세대정보 확인 동의',
        depth3: '약관 동의',
        depth4: '',
        depth5: '',
        name: '온라인 전입세대정보 확인 동의 약관동의',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1043-F',
        plan: '25.07.04',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250702:알아두세요위치수정',
        uxw: true,
    },
    {
        depth2: '온라인 전입세대정보 확인 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '온라인 전입세대정보 확인 동의 동의 완료안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1044-F',
        plan: '25.07.04',
        end: '25.06.23',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '한국부동산원 비대면 동의',
        depth3: '고객정보 입력',
        depth4: '',
        depth5: '',
        name: '한국부동산원 비대면 동의 고객정보 입력',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1050-F',
        plan: '25.06.17',
        end: '25.06.17',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '한국부동산원 비대면 동의',
        depth3: '약관 동의',
        depth4: '',
        depth5: '',
        name: '한국부동산원 비대면 동의 약관 동의',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1052-F',
        plan: '25.06.17',
        end: '25.06.17',
        user: '김익중',
        state: '완료',
        etc: '25.06.17 최초완료, 25.06.23 꼭 알아두세요 수정',
        uxw: true,
    },
    {
        depth2: '한국부동산원 비대면 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '한국부동산원 비대면 동의 동의 완료안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1053-F',
        plan: '25.06.17',
        end: '25.06.17',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '개인신용정보 마케팅활용 동의',
        depth3: '동의 내용안내',
        depth4: '',
        depth5: '',
        name: '개인신용정보 마케팅활용 동의 동의 내용안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1060-F',
        plan: '25.06.18',
        end: '25.06.17',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '개인신용정보 마케팅활용 동의',
        depth3: '마케팅 수신 동의',
        depth4: '',
        depth5: '',
        name: '개인신용정보 마케팅활용 동의 마케팅 수신동의',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1062-F',
        plan: '25.06.18',
        end: '25.06.17',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '개인신용정보 마케팅활용 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '개인신용정보 마케팅활용 동의 동의 완료안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1063-F',
        plan: '25.06.18',
        end: '25.06.17',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '공공마이데이터 무방문 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '공공마이데이터 무방문 동의 동의 내용안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1080-F',
        plan: '25.07.04',
        end: '25.06.24',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250702:알아두세요위치수정',
        uxw: true,
    },
    {
        depth2: '공공마이데이터 무방문 동의',
        depth3: '서비스 신청불가 안내',
        depth4: '',
        depth5: '',
        name: '공공마이데이터 무방문 동의 서비스 신청불가 안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1081-F',
        plan: '25.07.04',
        end: '25.06.24',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '공공마이데이터 무방문 동의',
        depth3: '약관 동의',
        depth4: '',
        depth5: '',
        name: '공공마이데이터 무방문 동의 약관 동의',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1082-F',
        plan: '25.07.04',
        end: '25.06.24',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '공공마이데이터 무방문 동의',
        depth3: '동의 완료안내',
        depth4: '',
        depth5: '',
        name: '공공마이데이터 무방문 동의 동의 완료안내',
        type: 'PAGE',
        dir: 'doc',
        id: 'SC-DOC-1083-F',
        plan: '25.07.04',
        end: '25.06.24',
        user: '김익중',
        state: '완료',
        etc: '최신소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
]

export default doc
